export default __webpack_public_path__ + "static/media/logo26.cbf79f4c.jpg";